import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import messages from "components/messagesDescription";
import { injectIntl, FormattedMessage } from "react-intl";
import classNames from "classnames";

const ContentItem = ({
  contentId,
  title,
  providerName,
  summaryHtml,
  imageLnkFull,
  coverImageLnkFull,
  contentType,
  detailsKey,
}) => {
  const iconClass =
    contentType && contentType !== "article"
      ? classNames("content_box_icon", contentType)
      : "content_box_icon";

  return (
    <article className="promo">
      <figure>
        <Link to={`/wellness/elibrary/catalogue/${detailsKey}`}>
          <img
            src={imageLnkFull && imageLnkFull !== "" ? imageLnkFull : coverImageLnkFull}
            alt=""
          />
        </Link>
      </figure>
      <header>
        <h4>
          <Link to={`/wellness/elibrary/catalogue/${detailsKey}`}>{title}</Link>
        </h4>
      </header>
      <section>
        <p>{providerName}</p>
        <div dangerouslySetInnerHTML={{ __html: summaryHtml }} />
      </section>
      {contentType && contentType !== "article" && <div className={iconClass}>icon</div>}
    </article>
  );
};

ContentItem.propTypes = {
  contentId: PropTypes.string,
  detailsKey: PropTypes.string,
  title: PropTypes.string,
  providerName: PropTypes.string,
  summaryHtml: PropTypes.string,
  imageLnkFull: PropTypes.string,
  coverImageLnkFull: PropTypes.string,
  contentType: PropTypes.string,
};

const RecommendedContent = ({ contents }) =>
  contents &&
  contents.length !== 0 && (
    <article className="card">
      <header>
        <h2>
          <FormattedMessage {...messages.suggestedContentDescription} />
        </h2>
        <p>
          <Link to="wellness/elibrary/catalogue">
            <FormattedMessage {...messages.viewAllDescription} />
          </Link>
        </p>
      </header>
      {contents &&
        contents.map((item, idx) => (
          <section key={`recommendedOffers__${idx}`}>
            <ContentItem {...item} />
          </section>
        ))}
    </article>
  );

RecommendedContent.propTypes = {
  contents: PropTypes.array,
};

export default injectIntl(RecommendedContent);



// WEBPACK FOOTER //
// ./components/dashboard/widgets/RecommendedContent.js